
import ProjectOptions from '@/components/projects/summary/ProjectOptions.vue';
import UploadProjectFilesModal from '@/components/projects/create/upload/UploadProjectFilesModal.vue';
import projectService from '@/services/ProjectService';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IProject, IProjectFile } from '@/types/resource.types';

@Component({
    name: 'AddFilesToProjectModal',
    components: {
        ProjectOptions,
        UploadProjectFilesModal
    }
})
export default class AddFilesToProjectModal extends Vue {

    /* Props
    ============================================*/

    @Prop({type: Object as () => IProject, required: true})
    readonly project: IProject;

    /* Data
    ============================================*/

    showUploadModal: boolean = false;

    /* Methods
    ============================================*/

    async handleUploadComplete(files: IProjectFile[]) {
        this.showUploadModal = false;

        try {
            const latestProject = await projectService.get(this.project.id);
            await projectService.submitProject(latestProject);
        } catch(e) {
            this.$toast.error('There was a problem submitting this project. Please try again');
            this.$logger.logError(e);
        } finally {
            this.$emit('uploadComplete', files);
        }
    }
}
